import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../../../lib/api'; // ✅ Relative path
import { FiUser, FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { toast } from 'react-hot-toast';

const Register = () => {
  const [formData, setFormData] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password!== formData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await api.register({
        name: formData.name,
        email: formData.email,
        password: formData.password
      });
      
      if (res.success) {
        toast.success('Registration successful! Please login.');
        navigate('/login');
      } else {
        toast.error(res.message || 'Registration failed');
      }
    } catch (error) {
      toast.error('Something went wrong');
    }
    setLoading(false);
  };

  return (
    <>
      <style>{`
       .auth-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #667EEA 0%, #764BA2 100%); padding: 20px; }
       .auth-card { background: rgba(255,255,255,0.95); backdrop-filter: blur(20px); border-radius: 24px; padding: 50px 40px; width: 100%; max-width: 420px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
       .auth-logo { text-align: center; margin-bottom: 30px; }
       .logo-icon { width: 70px; height: 70px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); border-radius: 16px; display: inline-flex; align-items: center; justify-content: center; font-size: 32px; color: #FFF; margin-bottom: 16px; }
       .auth-title { font-size: 28px; font-weight: 800; color: #0F172A; margin: 0 0 8px 0; }
       .auth-subtitle { color: #64748B; font-size: 15px; }
       .form-group { margin-bottom: 20px; }
       .input-wrapper { position: relative; }
       .input-icon { position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #94A3B8; font-size: 18px; }
       .form-input { width: 100%; padding: 14px 16px 14px 48px; border: 2px solid #E2E8F0; border-radius: 12px; font-size: 15px; box-sizing: border-box; }
       .form-input:focus { outline: none; border-color: #3B82F6; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1); }
       .password-toggle { position: absolute; right: 16px; top: 50%; transform: translateY(-50%); background: none; border: none; color: #94A3B8; cursor: pointer; font-size: 18px; }
       .auth-btn { width: 100%; padding: 14px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); color: #FFF; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; }
       .auth-btn:disabled { opacity: 0.6; cursor: not-allowed; }
       .auth-link { text-align: center; margin-top: 20px; color: #64748B; font-size: 14px; }
       .auth-link a { color: #3B82F6; font-weight: 600; text-decoration: none; }
      `}</style>
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo">
            <div className="logo-icon">Z</div>
            <h1 className="auth-title">Create Account</h1>
            <p className="auth-subtitle">Sign up to get started</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-wrapper">
                <FiUser className="input-icon" />
                <input type="text" className="form-input" placeholder="Full Name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input type="email" className="form-input" placeholder="Email address" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required />
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input type={showPassword? 'text' : 'password'} className="form-input" placeholder="Password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} required />
                <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input type={showPassword? 'text' : 'password'} className="form-input" placeholder="Confirm Password" value={formData.confirmPassword} onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})} required />
              </div>
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading? 'Creating Account...' : 'Sign Up'}
            </button>
          </form>
          <div className="auth-link">
            Already have an account? <Link to="/login">Sign In</Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default Register;